interface IPayload {
    filename: string;
}

export const deleteProductImage = (payload: IPayload) => ({
    type: "@saga/DELETE_PRODUCT_IMAGE",
    payload
});